import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/**
 * Given an AST with parse errors, this visitor returns a valid query that is equivalent for hydration purposes
 * (i.e. just fields, operators and values). Resulting query is generated on a best-effort basis and depends on
 * a successful parser error recovery.
 *
 * Example 1:
 * - Original query: "assignee in (abc-123-def"
 * - Equivalent query: "assignee in (abc-123-def)"
 *
 * Example 2:
 * - Original query: "project = EM and status in (Done, currentUser(), EMPTY) and reporter in"
 * - Equivalent query: "project = EM and status in (Done)"
 */
export var ValidQueryVisitor = function ValidQueryVisitor() {
  var _this = this;

  _classCallCheck(this, ValidQueryVisitor);

  _defineProperty(this, "visitQuery", function (query) {
    if (!query.where) return '';
    return query.where.accept(_this);
  });

  _defineProperty(this, "visitCompoundClause", function (compoundClause) {
    return compoundClause.clauses.map(function (clause) {
      return clause.accept(_this);
    }).filter(function (value) {
      return !!value;
    }).join(' and ');
  });

  _defineProperty(this, "visitTerminalClause", function (terminalClause) {
    var field = terminalClause.field,
        operator = terminalClause.operator,
        operand = terminalClause.operand;
    if (!operator || !operand) return '';
    var operandValue = operand.accept(_this);
    if (!operandValue) return '';
    return "".concat(field.text, " ").concat(operator.value, " ").concat(operandValue);
  });

  _defineProperty(this, "visitValueOperand", function (valueOperand) {
    return valueOperand.text;
  });

  _defineProperty(this, "visitListOperand", function (listOperand) {
    return "(".concat(listOperand.values.map(function (value) {
      return value.accept(_this);
    }).filter(function (value) {
      return !!value;
    }).join(', '), ")");
  });

  _defineProperty(this, "visitNode", function () {
    return '';
  });
};